import http from "../http-rda";

class DataService {
  getAll(params) {
    return http.get("/teacher-notifications", { params });
  }

  getCounts() {
    return http.get("/teacher-notifications/counts");
  }

  create(data) {
    return http.post("/teacher-notifications", data);
  }

  update(id, data) {
    return http.patch(`/teacher-notifications/${id}`, data);
  }

  remove(id) {
    return http.delete(`/teacher-notifications/${id}`);
  }

  markRead(id) {
    return http.patch(`/teacher-notifications/${id}/read`);
  }
}

export default new DataService();
